import { render } from "./BackgroundCollectionComplete.vue?vue&type=template&id=6a01a66a&scoped=true"
import script from "./BackgroundCollectionComplete.vue?vue&type=script&lang=js"
export * from "./BackgroundCollectionComplete.vue?vue&type=script&lang=js"

import "./BackgroundCollectionComplete.vue?vue&type=style&index=0&id=6a01a66a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a01a66a"]])

export default __exports__